import { render, staticRenderFns } from "./ArticleTitle.vue?vue&type=template&id=2737d3c5&scoped=true&"
import script from "./ArticleTitle.vue?vue&type=script&lang=js&"
export * from "./ArticleTitle.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTitle.vue?vue&type=style&index=0&id=2737d3c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2737d3c5",
  null
  
)

export default component.exports